// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32fj_","content":"styles_content__1Lgo5"};